<script setup lang="ts">

const employer_store = useEmployerStore()

const items = computed<any[]>(() => employer_store.all.map((employer) => ({
  label: employer.name,
    avatar: {
    src: 'https://avatars.githubusercontent.com/u/23360933?s=200&v=4'
  },
  
  click: () => {
    employer_store.current = employer
  }
})));

/*const actions = [{
  label: 'Create team',
  icon: 'i-heroicons-plus-circle'
}, {
  label: 'Manage teams',
  icon: 'i-heroicons-cog-8-tooth'
}]*/

</script>

<template>
  <UDropdown v-slot="{ open }" mode="hover" :items="[items]" class="w-full" :ui="{ width: 'w-full' }"
    :popper="{ strategy: 'absolute' }">
    <UButton color="gray" variant="ghost" :class="[open && 'bg-gray-50 dark:bg-gray-800']" class="w-full">
      <UAvatar src="https://avatars.githubusercontent.com/u/23360933?s=200&v=4" size="2xs" />
      <span class="truncate text-gray-900 dark:text-white font-semibold">{{ employer_store.current.name }}</span>
    </UButton>
  </UDropdown>
</template>
